/* @flow */
import * as React from 'react';

import { Box } from '@sonyged/proc-ui';
import css from '@styled-system/css';
import styled from 'styled-components';

import { SUSHI_ICON_SIZE, SUSHI_ICON_MARGIN, SUSHI_ICON_BORDER } from './constants';
import { SushiContext } from '../../SushiContext';
import type { Sushi as SushiType } from '../../rules/types';
import IFIN from '../../../assets/images/pages/sushi/sushi_field_sim-finish@3x.png';

type Props = {
  status: 'hidden' | 'visible' | 'eating' | 'finish',
  sushi: SushiType,
  scale?: number,
};

export function SushiIcon(props: Props) {
  const { status, sushi, scale = 1 } = props;
  const mapper = React.useContext(SushiContext);

  const style = React.useMemo(
    () => ({
      width: scale * SUSHI_ICON_SIZE,
      height: scale * SUSHI_ICON_SIZE,
      borderWidth: scale * SUSHI_ICON_BORDER,
      marginLeft: scale * SUSHI_ICON_MARGIN,
      marginRight: scale * SUSHI_ICON_MARGIN,
    }),
    [scale]
  );

  return (
    <Container status={status} style={style}>
      <Bg />
      <Img src={mapper.getSushiBwIcon(sushi)} alt="sushi icon" />
      {status === 'finish' && <Img src={IFIN} alt="X icon" />}
    </Container>
  );
}

const Container = styled(Box)(
  css({
    display: 'inline-block',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: 9999,
    borderColor: 'transparent',
    borderStyle: 'solid',
    transform: 'translate3d(0,0,0)', // hack: force gpu rendering on iOS 10
  }),
  ({ status }) => {
    if (status === 'hidden' || status === 'finish') return { opacity: 0.5 };
    if (status === 'eating') return css({ borderColor: 'attention100' });
  }
);

const common = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
};

const Img = styled('img')(common);
const Bg = styled(Box)(common, { backgroundColor: 'white' });
